import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e34888c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = {
  class: "modal fade",
  id: "newsletterModal",
  tabindex: "-1",
  "aria-labelledby": "newsletterModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-xl" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "text-block" }
const _hoisted_10 = { class: "visually-hidden" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = {
  for: "newsletter-first-name-input",
  class: "grey"
}
const _hoisted_14 = ["placeholder", "aria-label", "aria-invalid", "aria-describedby"]
const _hoisted_15 = {
  key: 0,
  id: "first-name-error",
  class: "name-error"
}
const _hoisted_16 = { class: "input-wrapper" }
const _hoisted_17 = {
  for: "newsletter-last-name-input",
  class: "grey"
}
const _hoisted_18 = ["placeholder", "aria-label", "aria-invalid", "aria-describedby"]
const _hoisted_19 = {
  key: 0,
  id: "last-name-error",
  class: "name-error"
}
const _hoisted_20 = { class: "input-wrapper" }
const _hoisted_21 = {
  for: "newsletter-email-input",
  class: "grey"
}
const _hoisted_22 = ["placeholder", "aria-label", "aria-invalid", "aria-describedby"]
const _hoisted_23 = {
  key: 0,
  id: "email-error",
  class: "email-error"
}
const _hoisted_24 = { class: "input-wrapper" }
const _hoisted_25 = {
  for: "newsletter-phone-input",
  class: "grey"
}
const _hoisted_26 = ["placeholder", "aria-label", "aria-invalid", "aria-describedby"]
const _hoisted_27 = {
  key: 0,
  id: "phone-error",
  class: "phone-error"
}
const _hoisted_28 = { class: "checkbox__group" }
const _hoisted_29 = ["aria-invalid"]
const _hoisted_30 = {
  class: "checkbox__label",
  for: "termsCheckbox"
}
const _hoisted_31 = {
  key: 0,
  id: "terms-error",
  class: "terms-error"
}
const _hoisted_32 = { class: "turnstile-block" }
const _hoisted_33 = {
  key: 0,
  id: "turnstile-error",
  class: "turnstile-error",
  role: "alert"
}
const _hoisted_34 = { class: "message-block" }
const _hoisted_35 = { class: "text-block" }
const _hoisted_36 = { role: "alert" }
const _hoisted_37 = { class: "input-wrapper" }
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = ["aria-label"]
const _hoisted_40 = ["aria-label"]

import { nextTick, onMounted, onBeforeUnmount, computed, ref } from 'vue'
import { useNewsletterStore } from '@/stores/newsletterStore'
import { renderTurnstile, resetTurnstile, removeTurnstile } from '@/services/turnstile.service'

// Supplied from Razor via data-* attributes on the mount element (see DefaultFooter.cshtml).

export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterPopup',
  props: {
    turnstileSitekey: null,
    turnstileAction: null
  },
  setup(__props: any) {

const props = __props as {
    turnstileSitekey?: string
    turnstileAction?: string
};



const newsletterStore = useNewsletterStore()

const isError = ref<boolean>(false)
const isTerms = ref<boolean>(false)
const firstName = ref<string>('')
const lastName = ref<string>('')
const email = ref<string>('')
const phoneNumber = ref<string>('')
const isSubmitted = ref<boolean>(false)
const isInvalidEmail = ref<boolean>(false)
const isInvalidFirstName = ref<boolean>(false)
const isInvalidLastName = ref<boolean>(false)
const isInvalidPhoneNumber = ref<boolean>(false)
const isInvalidTerms = ref<boolean>(false)
const closeModalButton = ref<HTMLElement | undefined>()
const newstellerPopubOpenBtn = ref<HTMLElement | undefined>()
const phoneNumberError = ref<string>('')

const turnstileContainer = ref<HTMLElement | undefined>()
const turnstileWidgetId = ref<string | null>(null)
const turnstileToken = ref<string>('')
const isInvalidTurnstile = ref<boolean>(false)

const openButton = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.OpenButton') ?? '')
const firstNameField = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.FirstNameField') ?? '')
const lastNameField = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.LastNameField') ?? '')
const emailField = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.EmailField') ?? '')
const phoneNumberField = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.PhoneField') ?? '')
const emailFieldError = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.EmailField.Error') ?? '')
const firstNameFieldError = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.FirstNameField.Error') ?? '')
const lastNameFieldError = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.LastNameField.Error') ?? '')
const phoneNumberFieldError = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.PhoneField.Error') ?? '')
const phoneNumberFieldEmptyError = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.PhoneField.Empty') ?? '')
const termsFieldError = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.Policy.Error') ?? '')
const submitButton = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.SubmitButton') ?? '')
const closeButton = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.CloseButton') ?? '')
const tryAgainButton = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.TryAgainButton') ?? '')
const newsletterPopupTitle = computed(() => newsletterStore.getLocalization('newsletterPopupTitle') ?? '')
const newsletterPopupSubtitle = computed(() => newsletterStore.getLocalization('newsletterPopupSubtitle') ?? '')
const terms = computed(() => newsletterStore.getLocalization('newsletterPopupPolicy') ?? '')
const thanksMsg = computed(() => newsletterStore.getLocalization('newsletterThankMessage') ?? '')
const errorMsg = computed(() => newsletterStore.getLocalization('Layout.NewsletterPopup.ErrorMessage') ?? '')
// Falls back to the generic error copy if the dictionary item has not been imported yet.
const turnstileErrorText = computed(() =>
    newsletterStore.getLocalization('Layout.NewsletterPopup.Turnstile.Error') || errorMsg.value)
const formDescription = computed(() => newsletterStore.getLocalization('Accessability.Form.Description') ?? '')

// Every field on this form is mandatory, and the design marks that on the label as well as inside
// the input.
const required = (label: string) => `${label} *`

const onSubmitNewsletter = async () => {
    const isValidFirstName = checkFirstNameValidation();
    const isValidLastName = checkLastNameValidation();
    const isValidEmail = checkEmailValidation();
    const isValidPhone = checkPhoneNumberValidation();
    const isValidTerms = checkTermsValidation();

    const isFormValid = isValidFirstName && isValidLastName && isValidEmail && isValidPhone && isValidTerms;

    if (!isFormValid) {
        // Indexes into the .newsletter-input elements in DOM order - keep this list in the same
        // order as the fields in the template above.
        const errorIndex = [
            !isValidFirstName,
            !isValidLastName,
            !isValidEmail,
            !isValidPhone,
            !isValidTerms
        ].indexOf(true);

        if (errorIndex !== -1) {
            document.querySelectorAll<HTMLElement>('.newsletter-input')[errorIndex]?.focus();
        }

        return;
    }

    // The server rejects a submission without a valid token, so stop here rather than spend an
    // attempt. This is a usability guard, not a security one: the real check is server-side.
    if (!turnstileToken.value) {
        isInvalidTurnstile.value = true;
        turnstileContainer.value?.scrollIntoView({ block: 'nearest' });
        return;
    }

    isInvalidTurnstile.value = false;

    const isOK = await newsletterStore.postNewsletter(
        firstName.value,
        lastName.value,
        email.value,
        phoneNumber.value,
        isTerms.value,
        turnstileToken.value
    );

    // The token has been spent. The widget itself stays alive behind v-show while the result message
    // is on screen; the fresh challenge is issued from onTryAgain instead, once the form is visible
    // again, because Turnstile stalls when it is reset inside a display:none container.
    turnstileToken.value = '';

    isSubmitted.value = true;
    isError.value = !isOK;
};

// The error path returns the user to the same form and the same widget. Turnstile tokens are
// single-use, so the retry needs a fresh challenge before it can submit anything.
const onTryAgain = async () => {
    isError.value = false;
    isSubmitted.value = false;

    // Let v-show reveal the form before touching the widget.
    await nextTick();

    resetTurnstile(turnstileWidgetId.value);

    // Covers the case where the first render never produced a widget at all - a blocked or failed
    // Turnstile script would otherwise leave the retry with nothing to solve.
    await ensureTurnstileRendered();
};

function checkEmailValidation(): boolean {
    const isValid = newsletterStore.isEmailValid(email.value);
    isInvalidEmail.value = !isValid;
    return isValid;
}

function checkFirstNameValidation(): boolean {
    const isValid = newsletterStore.isNameValid(firstName.value);
    isInvalidFirstName.value = !isValid;
    return isValid;
}

function checkLastNameValidation(): boolean {
    const isValid = newsletterStore.isNameValid(lastName.value);
    isInvalidLastName.value = !isValid;
    return isValid;
}

function checkPhoneNumberValidation(): boolean {
    const value = phoneNumber.value.trim();

    if (!value) {
        isInvalidPhoneNumber.value = true;
        phoneNumberError.value = phoneNumberFieldEmptyError.value;
        return false;
    }

    const isValid = newsletterStore.isPhoneNumberValid(value);
    isInvalidPhoneNumber.value = !isValid;
    phoneNumberError.value = isValid ? '' : phoneNumberFieldError.value;
    return isValid;
}

function checkTermsValidation(): boolean {
    const isValid = isTerms.value;
    isInvalidTerms.value = !isValid;
    return isValid;
}

// Rendered the first time the modal is opened, so the Cloudflare script is not fetched on every
// page view of the site — the footer that hosts this component is on every page.
let isRenderingTurnstile = false

const ensureTurnstileRendered = async () => {
    // isRenderingTurnstile closes the window between the await below and the widget id landing in the
    // ref: two triggers inside it would otherwise render twice and leak the first widget.
    if (turnstileWidgetId.value !== null || isRenderingTurnstile || !turnstileContainer.value) {
        return
    }

    if (!props.turnstileSitekey) {
        console.warn('Turnstile site key missing; newsletter submissions will be rejected by the server.')
        return
    }

    isRenderingTurnstile = true

    try {
        turnstileWidgetId.value = await renderTurnstile(turnstileContainer.value, {
            sitekey: props.turnstileSitekey,
            action: props.turnstileAction ?? 'newsletter_subscribe',
            onToken: (token) => {
                turnstileToken.value = token
                isInvalidTurnstile.value = false
            },
            onExpiredOrError: () => {
                // The held token is no longer redeemable; force a fresh challenge before any submit.
                turnstileToken.value = ''
            },
        })
    } catch (error) {
        console.warn('Turnstile failed to load', error)
    } finally {
        isRenderingTurnstile = false
    }
}

onMounted(async () => {
    await newsletterStore.fetchNewsletter()

    const socialBtn = document.querySelector('#newsteller-social-btn')

    if (socialBtn !== null) {
        socialBtn.setAttribute('data-bs-toggle','modal')
        socialBtn.setAttribute('data-bs-target','#newsletterModal')
    }

    document
        .getElementById('newsletterModal')
        ?.addEventListener('shown.bs.modal', ensureTurnstileRendered)
})

onBeforeUnmount(() => {
    document
        .getElementById('newsletterModal')
        ?.removeEventListener('shown.bs.modal', ensureTurnstileRendered)
    removeTurnstile(turnstileWidgetId.value)
    turnstileWidgetId.value = null
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        id: "newsletterModalLabel",
        class: "btn btn-primery btn-primery-green",
        type: "button",
        ref_key: "newstellerPopubOpenBtn",
        ref: newstellerPopubOpenBtn,
        "data-bs-toggle": "modal",
        "data-bs-target": "#newsletterModal"
      }, _toDisplayString(_unref(openButton)), 513)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              ref_key: "closeModalButton",
              ref: closeModalButton,
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": _unref(closeButton)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formDescription)), 1),
                    _createElementVNode("h3", null, _toDisplayString(_unref(newsletterPopupTitle)), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(newsletterPopupSubtitle)), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-block", isInvalidFirstName.value ? 'field-error' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(required(_unref(firstNameField))), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "newsletter-first-name-input",
                        class: "input newsletter-input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
                        name: "firstName",
                        placeholder: required(_unref(firstNameField)),
                        "aria-label": _unref(firstNameField),
                        onInput: checkFirstNameValidation,
                        "aria-required": "true",
                        "aria-invalid": isInvalidFirstName.value || undefined,
                        "aria-describedby": isInvalidFirstName.value ? 'first-name-error' : '',
                        autocomplete: "given-name",
                        type: "text"
                      }, null, 40, _hoisted_14), [
                        [_vModelText, firstName.value]
                      ]),
                      (isInvalidFirstName.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(firstNameFieldError)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-block", isInvalidLastName.value ? 'field-error' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(required(_unref(lastNameField))), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "newsletter-last-name-input",
                        class: "input newsletter-input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastName).value = $event)),
                        name: "lastName",
                        placeholder: required(_unref(lastNameField)),
                        "aria-label": _unref(lastNameField),
                        onInput: checkLastNameValidation,
                        "aria-required": "true",
                        "aria-invalid": isInvalidLastName.value || undefined,
                        "aria-describedby": isInvalidLastName.value ? 'last-name-error' : '',
                        autocomplete: "family-name",
                        type: "text"
                      }, null, 40, _hoisted_18), [
                        [_vModelText, lastName.value]
                      ]),
                      (isInvalidLastName.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(lastNameFieldError)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-block", isInvalidEmail.value ? 'field-error' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(required(_unref(emailField))), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "newsletter-email-input",
                        class: "input newsletter-input",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                        name: "email",
                        placeholder: required(_unref(emailField)),
                        "aria-label": _unref(emailField),
                        onInput: checkEmailValidation,
                        "aria-invalid": isInvalidEmail.value || undefined,
                        "aria-describedby": isInvalidEmail.value ? 'email-error' : '',
                        "aria-required": "true",
                        autocomplete: "email",
                        type: "email"
                      }, null, 40, _hoisted_22), [
                        [_vModelText, email.value]
                      ]),
                      (isInvalidEmail.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_unref(emailFieldError)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-block", isInvalidPhoneNumber.value ? 'field-error' : ''])
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(required(_unref(phoneNumberField))), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "newsletter-phone-input",
                        class: "input newsletter-input",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((phoneNumber).value = $event)),
                        name: "phone",
                        placeholder: required(_unref(phoneNumberField)),
                        "aria-label": _unref(phoneNumberField),
                        onInput: checkPhoneNumberValidation,
                        "aria-invalid": isInvalidPhoneNumber.value || undefined,
                        "aria-describedby": isInvalidPhoneNumber.value ? 'phone-error' : '',
                        "aria-required": "true",
                        type: "tel"
                      }, null, 40, _hoisted_26), [
                        [_vModelText, phoneNumber.value]
                      ]),
                      (isInvalidPhoneNumber.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(phoneNumberError.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["checkbox__item", isInvalidTerms.value ? 'field-error' : ''])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "checkbox__input newsletter-input",
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isTerms).value = $event)),
                        onChange: checkTermsValidation,
                        "aria-required": "true",
                        "aria-invalid": isInvalidTerms.value || undefined,
                        id: "termsCheckbox"
                      }, null, 40, _hoisted_29), [
                        [_vModelCheckbox, isTerms.value]
                      ]),
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(terms)) + " *", 1),
                      (isInvalidTerms.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_unref(termsFieldError)), 1))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", {
                      ref_key: "turnstileContainer",
                      ref: turnstileContainer
                    }, null, 512),
                    (isInvalidTurnstile.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_unref(turnstileErrorText)), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, !isSubmitted.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("h3", _hoisted_36, _toDisplayString(isError.value ? _unref(errorMsg) : _unref(thanksMsg)), 1)
                  ])
                ], 512), [
                  [_vShow, isSubmitted.value]
                ]),
                _createElementVNode("div", _hoisted_37, [
                  (!isSubmitted.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: onSubmitNewsletter,
                        class: "btn btn-primery btn-primery-green",
                        type: "submit",
                        "aria-label": _unref(submitButton)
                      }, _toDisplayString(_unref(submitButton)), 9, _hoisted_38))
                    : (!isError.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (closeModalButton.value?.click())),
                          class: "btn btn-primery btn-primery-green",
                          type: "button",
                          "aria-label": _unref(closeButton)
                        }, _toDisplayString(_unref(closeButton)), 9, _hoisted_39))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: onTryAgain,
                          class: "btn btn-primery btn-primery-green",
                          type: "button",
                          "aria-label": _unref(tryAgainButton)
                        }, _toDisplayString(_unref(tryAgainButton)), 9, _hoisted_40))
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})